import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import RecallItems from './components/RecallItems';

const recallItems = (props,{ t }) => (
  <Container>
    <RecallItems {...props} />
  </Container>
);

recallItems.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(recallItems);
